import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import ROUTES from '~/shared/constants/routes.const'
import Button from '~/components/Buttons/Button'

export default function TestPrep({
  isAllowed,
  isComingSoon,
}: {
  isAllowed: boolean
  isComingSoon: boolean
}): React.ReactElement {
  const { t } = useTranslation('onboarding')

  return (
    <div className="items-center w-full h-full text-center">
      <div className="flex flex-col py-2 h-full gap-4 md:gap-0">
        <h2 className="mx-2 justify-center font-bold text-white text-sm">{t('testPrepArena')}</h2>
        <div className="flex flex-col flex-1 justify-center items-center gap-1 min-h-23 md:min-h-20">
          <div className="" onClick={() => {}}>
            <ResponsiveImage
              alt="Certificate"
              height={48}
              imageClassName="w-20 md:w-35 lg:w-21"
              srcKey={`${
                isAllowed ? 'icons/products/test_prep_badge.png' : isComingSoon ? 'dashboard/test-prep-coming.png' : ''
              }`}
              width={48}
            />
          </div>
        </div>
        <Button
          className="bg-purple mx-auto h-9 w-9/10 shadow-purple-drop-glow !rounded-full font-bold text-xs"
          disabled={!isAllowed && isComingSoon}
          href={ROUTES.TEST_START}
        >
          {t('getTest')}
        </Button>
      </div>
    </div>
  )
}
